import { render, staticRenderFns } from "./FormFaculte.vue?vue&type=template&id=00f041ec&"
import script from "./FormFaculte.vue?vue&type=script&lang=js&"
export * from "./FormFaculte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports